/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetAllFilingGenericSubmissionTypes: {
        $xmlns: 'http://dobs.pa.gov/dp/lookup/bpm/1.0'
      }
    },
    blueprintArrays: ['GetAllFilingGenericSubmissionTypesResponse.DP_LU_GenericSubmissionType'],
    blueprint: {
      submissionTypes: [
        '$..DP_LU_GenericSubmissionType',
        {
          id: '$..ID',
          name: '$..Name',
          entityCategoryId: '$..EntityCategoryID',
          instructionsDocument: {
            fileId: '$..InstructionsDocID',
            fileName: '$..InstructionsDocName'
          },
          instructions: '$..Instructions',
          filingFee: '$..FilingFee',
          isPaymentOutside: '$..IsPaymentOutside',
          isExternallyVisible: '$..IsExternallyVisible',
          orderPos: '$..OrderPos'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      _.each(response.submissionTypes, function(submissionType) {
        submissionType.filingFee = parseFloat(submissionType.filingFee);
      });
      deferred.resolve(response.submissionTypes);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
